import { z } from "zod";
import { ClearanceSchema } from "./enums.js";
import { LocaleSchema } from "./locale.js";

export const LoginRequest = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof LoginRequest>;

export const ChangePasswordRequest = z.object({
  current: z.string().min(1),
  new: z.string().min(8),
});
export type ChangePasswordRequest = z.infer<typeof ChangePasswordRequest>;

export const CurrentUser = z.object({
  id: z.number().int().positive(),
  email: z.string().email(),
  name: z.string(),
  role: z.enum(["admin", "editor", "viewer"]),
  clearance: ClearanceSchema,
  // Null means "never chosen" — the UI then follows Accept-Language. A
  // non-null default would assert that every existing user prefers German.
  locale: LocaleSchema.nullable(),
});
export type CurrentUser = z.infer<typeof CurrentUser>;
